import { useEffect } from 'react'
import { image } from '../../../../../utils/data/baseUrl'
import { getIsAvailableEvent, NEW_YEAR } from '../../../../../constants/events'
import useServiceData from '../../../../../hooks/useServiceData'
import { useModal } from '../../../../../hooks/useModal'
import useGetIsTruthTime from '../../../../../hooks/shared/time/useGetIsTruthTime'
import { BUTTONS, IMAGE, TEXT, TITLE } from '../../../../modals/universalModal'
import { defaultStore } from '../../../../../translations'

export default function useNewYearProfileModal() {
  const { get, save } = useServiceData()
  const { addModal } = useModal()
  const getIsTruthTime = useGetIsTruthTime()

  useEffect(() => {
    const modalsData = get('modalsData') ?? {}

    if (
      !modalsData?.newYearProfile2026 &&
      getIsAvailableEvent(defaultStore, NEW_YEAR) &&
      getIsTruthTime({ forAll: '2026-01-01T00:00' })
    ) {
      addModal({
        type: 'universalModal',
        props: {
          modalProps: {
            wrapper: { isFullPage: false },
            modifier: ['noFullNoScroll', 'width-image-full'],
          },
          components: [
            {
              list: [
                {
                  type: IMAGE,
                  props: {
                    modifier: 'width-full',
                    img: image('ny/profile.png'),
                  },
                },
                {
                  type: TITLE,
                  props: {
                    modifier: 'padding-no',
                    value: 'newYearProfileContent.title',
                  },
                },
                {
                  type: TEXT,
                  props: {
                    value: 'newYearProfileContent.text',
                  },
                },
                {
                  type: BUTTONS,
                  props: {
                    buttons: [
                      {
                        text: 'other.good',
                        disposable: true,
                        modalData: { action: 'close', data: { type: 'current' } },
                      },
                    ],
                  },
                },
              ],
            },
          ],
        },
      })
      save('modalsData', { ...modalsData, newYearProfile2026: true })
    }
  }, [])
}
